export default __webpack_public_path__ + "b0ca195e743b210db275bb4ba15d6732.svg";